import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const GetRateScheduleById = {
  name: 'GetRateScheduleById',
  state: {
    data: {},
    loading: false,
    error: '',
  },
  reducers: {
    fetchRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    fetchSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
      };
    },

    fetchFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
    clearData(state) {
        return {
          ...state,
          data: {},
          error: '', 
        };
      },
  },
  effects: (dispatch) => ({
    async fetchRateScheduleById({ Id, silent = false }) {
      try {
        this.fetchRequested();
        const response = await http.get(`savvy/rate-schedule/${Id}`);
        this.fetchSucceeded(response.data);

        if (!silent) {
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Rate Schedule fetched successfully!',
              show: true,
            },
          });
        }
      } catch (error) {
        this.fetchFailed(error.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },
    clearFetchedData() {
        this.clearData();
      },
  }),
};

export default GetRateScheduleById;
